module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAdgAAAHYBTnsmCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAADySURBVDiNpdMxSwNBEIbh54xKOhUs7QRNbW1lZSmBaG9hLdj7QyJoExBOFMFfINhqrYKVtYWFeAoGixvkuFzu1Ax8sLszO/Pu7G6CIyzgE094CD3iVYMlOEMPs1jGKlZCc8iwj5dxSdKGIjvojnNOFcb9EOxG4g6GaNVVaCLohf5NUGtJBG7XxHSxhTbucYs7PMN0iQD2gmATh/LzX+EiiNZwgCX5VU/Ug/O/9qC8/jUpQVokmJc/6xSnWK/YMEJWbOIGrjGQd/wEN6UEx6EfKxK08BHjTPXrqyX4jY0QJLiUf+U3LOI9fMMgzGLerkg48w1UbDdK5O+4/AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/enterprise/Add_New_Location.png
// module id = Nufm
// module chunks = 0